/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IRedundantBlock {
        name: string;
        primary: string;
        redundant: string;
        block: IBlock;
    }

    export interface IRedundancyGroup {
        name: string;
        redundancyIds: string;
        primary: string;
        redundant: string;
    }
}